import { TDefaultTheme } from '@lib/theme/defaultTheme';
import React from 'react';
import { PaperSC } from './paper.styled';

interface PaperProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  variant?: keyof TDefaultTheme['color']['surface'];
  type?: 'rounded' | 'default';
}

const Paper = (props: PaperProps, ref?: React.Ref<HTMLDivElement>) => {
  return <PaperSC ref={ref as any} {...props} type={props.type ?? 'rounded'} />;
};

export default React.forwardRef(Paper);
